import React, { useEffect, useState, useContext } from 'react'
import { LoginWrapper, FormWrapper, PasswordContainer } from './style'
import { InputLogin } from 'src/components/Global/Input/Input'
import { VerificationButton } from 'src/components/Global/Button/Button'
import { Link, useNavigate } from 'react-router-dom'
import { circleOne, numberInput } from 'src/assets'
import { checkEmailAction } from 'src/redux/actions/auth'
import { useDispatch } from 'react-redux'
import { AuthTypes } from 'src/redux/types/auth'
import { action } from 'typesafe-actions'
import useSnackbar from 'src/hooks/useSnackBar'
import { SnackbarContext } from 'src/contexts/Snack'
import {
  validateFirstSignup,
  validatePhoneNumber,
} from 'src/components/Validate/validate'
import { verifyUserAction } from 'src/redux/actions/auth'
const RegisterForm = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const snackbar = useSnackbar()
  let currentUrl = window.location.href
  let paramaters = new URL(currentUrl).searchParams
  let referral = paramaters.get('ref')
  const [userData, setUserData] = useState({
    first_name: '',
    phone_number: '',
    last_name: '',
    email: '',
    referred_by: referral,
  })
  const { first_name, last_name, email, phone_number } = userData
  useEffect(() => {
    if (phone_number.length === 10 && phone_number.charAt(0) !== '0') {
      let stringNumber = phone_number.toString()
      let newNumber: any
      if (stringNumber.charAt(0) === '0') {
      } else {
        newNumber = {
          phone_number: '0'.concat(stringNumber),
        }
      }
      const { error }: any = validatePhoneNumber(newNumber)
      if (error) {
        snackbar.trigger({
          message: 'THis phone Number is not valid',
          severity: 'warning',
        })
        return
      }
      let payload = { param: '0'.concat(stringNumber) }
      dispatch(verifyUserAction({ payload, onSuccess, onError }))
    }
    if (phone_number.length === 11) {
      const { error }: any = validatePhoneNumber({ phone_number })
      if (error) {
        snackbar.trigger({
          message: 'THis phone Number is not valid',
          severity: 'warning',
        })
        return
      }
      let payload = { param: phone_number }
      dispatch(verifyUserAction({ payload, onSuccess, onError }))
    }
  }, [phone_number, dispatch])
  const snackbarCtx: any = useContext(SnackbarContext)
  const { state: snackbarState } = snackbarCtx
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }
  const onSuccess = (msg: any) => {
    snackbar.trigger({
      message: 'This Phone number already exists',
      severity: 'error',
    })
    userData.phone_number = ''
  }
  const onError = (errorMsg: string) => {}
  const Proceed = (e: any) => {
    e.preventDefault()
    const error: any = validateFirstSignup(userData)
    if (error.error) {
      snackbar.trigger({
        message: error.error.message,
        severity: 'warning',
      })
      return
    }
    let payload = { param: email }
    dispatch(checkEmailAction({ payload, onSuccessEmail, onErrorEmail }))
  }
  const onSuccessEmail = (msg: any) => {
    snackbar.trigger({
      message: 'This Email Address already exists',
      severity: 'error',
    })
  }
  const onErrorEmail = (errorMsg: string) => {
    dispatch(action(AuthTypes._UPDATE_SIGN_UP_FORM, userData))
    navigate('/accounts/secure-password')
  }
  return (
    <LoginWrapper>
      <div className="welcome">
        <div>
          <h1>Let’s get started</h1>
          <p>Enter your personal details</p>
        </div>
        <div className="step">
          <img src={circleOne} alt="" />
          <div className="details">
            <p className="step-topic">Step 1</p>
            <p>Personal details</p>
          </div>
        </div>
      </div>
      <FormWrapper>
        <div className="name">
          <div className="each-form-name">
            <label>First name</label>
            <InputLogin
              type="text"
              name="first_name"
              value={first_name}
              onChange={handleChange}
            />
          </div>
          <div className="each-form-name lefty">
            <label>Last name</label>
            <InputLogin
              type="text"
              name="last_name"
              value={last_name}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="each-form">
          <label>Phone number</label>
          <PasswordContainer>
            <img src={numberInput} alt="" />
            <InputLogin
              type="tel"
              className="number"
              name="phone_number"
              value={phone_number}
              onChange={handleChange}
            />
          </PasswordContainer>
        </div>
        <div className="each-form">
          <label>Email address</label>
          <InputLogin
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
          />
        </div>
        <div className="each-form revert">
          <VerificationButton onClick={Proceed}>Proceed</VerificationButton>
          <Link to="/accounts/login" className="option-link">
            <p className="to-left">
              <span>Already have an account?</span> Log in
            </p>
          </Link>
        </div>
      </FormWrapper>
    </LoginWrapper>
  )
}

export { RegisterForm }
